import React, { useContext } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import DashboardContext from '../../context/DashboardContext';
import './Footer.css'; // We'll create this CSS file next

import logoSvg from '../../assets/app-logo-white.png';
import whatsappSvg from '../../assets/frame0.svg';
import linkedinSvg from '../../assets/frame1.svg';

const Footer = () => {
  const { activeTab } = useContext(DashboardContext);

  const getActiveTab = () => {
    return activeTab;
  }

  const getQueryType = () => {
    getActiveTab()
    if (activeTab === 'complainace') {

      return '?type=investorFeedbackSuggestion';
    }
    return '';
  };

  return (
    <footer className="footer-container text-white py-5"> {/* Use footer tag */}
      <Container fluid="lg"> {/* Use fluid="lg" for similar width behavior */}
        {/* Top Section: Logo, Social, Contact Button */}
        <Row className="align-items-center justify-content-between mb-5 footer-top-row">
          <Col md={8} lg={7} className="mb-4 mb-md-0">
            <div className="d-flex flex-column align-items-start">
              {/* Logo */}
              <div className="footer-logo-group mb-3">
                {/* Link (not onClick img) so the logo is keyboard-operable;
                    alt names the destination (audit round-2) */}
                <Link to="/">
                  <img src={logoSvg} alt="Right Spade Home" className="footer-logo-img" />
                </Link>
              </div>
              {/* Title — h2: footer follows the page's h2 sections, so h4 skipped
                  levels (audit round-2); visual style comes from .footer-title */}
              <h2 className="mb-3 footer-title">Ready to invest smarter?</h2>
              {/* Social Links */}
              <div className="d-flex align-items-center footer-social-links">
                <a href="https://api.whatsapp.com/send/?phone=916363219981" target="_blank" rel="noopener noreferrer" className="footer-top-link me-3 d-flex align-items-end">
                  Whatsapp Channel
                  <img src={whatsappSvg} alt="" className="footer-icon ms-1" />
                </a>
                <a href="https://www.linkedin.com/company/right-spade" target="_blank" rel="noopener noreferrer" className="footer-top-link d-flex align-items-end">
                  LinkedIn
                  <img src={linkedinSvg} alt="" className="footer-icon ms-1" />
                </a>
              </div>
            </div>
          </Col>
          <Col md="auto" className="text-md-end"> {/* auto width for button column */}
            <Button
              as={Link}
              to={`/query${getQueryType()}`}
              variant="light"
              className="footer-contact-btn"
            >
              Contact Us
            </Button>
          </Col>
        </Row>

        {/* Divider */}
        <hr className="footer-divider my-5" />

        {/* Bottom Section: Links & Compliance */}
        <Row className="footer-bottom-row gy-5"> {/* gy-5 adds vertical gap on small screens */}
          {/* Quick Links */}
          <Col xs={6} lg={12} className="mb-4 mb-lg-0">
            <h3 className="footer-section-title mb-4">Quick Links :</h3>
            <Row className="footer-quick-links">
              <Col xs={12} md={3} className="mb-2">
                <Link to="/legal#disclaimer" className="footer-link">Disclaimer</Link>
              </Col>
              <Col xs={12} md={3} className="mb-2">
                <Link to="/legal#disclosure" className="footer-link">Disclosure</Link>
              </Col>
              <Col xs={12} md={3} className="mb-2">
                <Link to="/legal#investor-charter" className="footer-link">Investor Charter</Link>
              </Col>
              <Col xs={12} md={3} className="mb-2">
                <Link to="/legal#complaints-data" className="footer-link">Complaints Data</Link>
              </Col>
              <Col xs={12} md={3} className="mb-2">
                <Link to="/legal#grievance-redressal" className="footer-link">Grievance Redressal</Link>
              </Col>
              <Col xs={12} md={3} className="mb-2">
                <Link to="/legal#news-policy" className="footer-link">News Policy</Link>
              </Col>
              <Col xs={12} md={3} className="mb-2">
                <Link to="/legal#refund-policy" className="footer-link">Refund Policy</Link>
              </Col>
              <Col xs={12} md={3} className="mb-2">
                <Link to="/legal#privacy-policy" className="footer-link">Privacy Policy</Link>
              </Col>
              <Col xs={12} md={3} className="mb-2">
                <Link to="/legal#terms-and-conditions" className="footer-link">T&amp;C of Website</Link>
              </Col>
            </Row>

          </Col>
          <Col xs={6} lg={12}>
            <h3 className="footer-section-title mb-4">Regulatory & Compliance :</h3>
            <div className="footer-compliance-text mb-3">
              SCORES: Clients may submit grievances directly to SEBI on the{' '}
              <Link to="https://scores.sebi.gov.in" target="_blank" rel="noopener noreferrer" className="footer-link-bold">SEBI SCORES portal</Link>
              {' '} | Get the SEBI SCORES mobile app →{' '}
              <Link to="https://play.google.com/store/apps/details?id=com.sebi" target="_blank" rel="noopener noreferrer" className="footer-link-bold">Android</Link>
              {' '}/{' '}
              <Link to="https://apps.apple.com/us/app/sebiscores/id6478849917" target="_blank" rel="noopener noreferrer" className="footer-link-bold">iOS</Link>
            </div>
            <div className="footer-compliance-text">
              ODR: Online Dispute Resolution Mechanism, as per SEBI regulations, is accessible on the{' '}
              <Link to="https://smartodr.in/intermediary-register" target="_blank" rel="noopener noreferrer" className="footer-link-bold">Smart ODR portal</Link>
              {' '} | BSE Enlistment No:{' '}
              <span className="enlist-no">6434</span>
            </div>
          </Col>
          {/* Regulatory & Compliance */}

        </Row>

        {/* Registered Address */}
        {/* <Row className="footer-address-row mt-4">
          <Col className="footer-address-text text-start">
            <span role="img" aria-label="location">ADDRESS : 📍</span>{' '}
            <a
              href="https://www.google.com/maps/place/3rd+floor,+1008,+7th+A+Main+Rd,+S.T.+Bed,+1st+Block+Koramangala,+Koramangala,+Bengaluru,+Karnataka+560034"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
              style={{ fontSize: '1rem', color: 'var(--white-color)' }}
            >
              3rd floor, 1008, 7th A Main Rd, S.T. Bed, 1st Block Koramangala, Koramangala, Bengaluru, Karnataka 560034
            </a>
          </Col>
        </Row> */}

        {/* Disclaimer */}
        <Row className="mt-5">
          <Col className="text-start footer-disclaimer-text">
            <p>
              Disclaimer: Investing involves risk. Past performance is not a guarantee of future results. Please do your own research or consult a financial advisor.
              Information on this website is gathered from public sources and is believed reliable, but Rightspade Capital Advisors Pvt Ltd makes no guarantees.
              Visit the <b>'Quick Links'</b> section for terms, disclosures and policies.
            </p>
          </Col>
        </Row>

        {/* Copyright */}
        <Row className="mt-5">
          <Col className="text-center footer-copyright">
            © {new Date().getFullYear()} Right Spade. All rights reserved.
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;